import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import Logo from '../assets/MALogo.svg'

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [validationErrors, setValidationErrors] = useState(null);
    const [emailSentConfirmation, setEmailSentConfirmation] = useState(false);
    const [timer, setTimer] = useState('5:00');
    const [processing, setProcessing] = useState(false);

    const navigate = useNavigate();

    const signUpValidation = () => {
        const errors = [];


        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errors.push('Please enter a valid email address');
        }
    
        setValidationErrors(errors);
        if (errors.length > 0) {
            return false;
        }
        
        return true;
    };

    const getUserDetails = async () => {

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/get-user-details`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ email })
            });

            const data = await response.json();
            
            if (data.success) {
                await sendResetPasswordEmail(data.userDetails);
            } else {
                // User not found or other error
                console.error('Error fetching user details:', data.message);
                setValidationErrors(["Email address was not found. Check for typos and try again."]);
            }
        } catch (error) {
            console.error('Error in getUserDetails:', error);
            setValidationErrors(['An error occurred while processing your request. Please try again later.']);
        }
    };

    const sendResetPasswordEmail = async (userDetails) => {

        const { userId, username, email } = userDetails;

        try {
            const response = await fetch(`${process.env.REACT_APP_API_BASE_URL}/auth/send-reset-password-email`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ userId, username, email })
            });

            const data = await response.json();

            if (data.success) {
                setValidationErrors(null);
                setEmailSentConfirmation(true);
                setTimer('5:00');
            } else {
                console.error('Error sending reset password email:', data.message);
                throw new Error(data.message);
            }
        } catch (error) {
            throw new Error(error);
        }
    };


    const handleForgotPassword = async (e) => {

        //NOTE: Work on this function later before deployment. Create the API endpoint from the backend under userController and userRoutes. Need to integrate AWS SES to send the email with the reset link.
        e.preventDefault();

        setProcessing(true);
        
        const validation = signUpValidation();
        
        if (!validation) {
            setProcessing(false);
            return;
        } else {
            getUserDetails(); // If found, this will call sendResetPasswordEmail internally
        }

        setProcessing(false);
        
        // const response = await signUp(username, email, password);

        // if (response.success) {
        //   setServerMessage(response);
        //   setEmailSentConfirmation(true);
        // } else {
        //   setServerMessage(response);
        // }
    };

    // Timer effect for resend email button
    useEffect(() => {
        let interval = null;

        if (emailSentConfirmation && timer !== '0:00') {
            interval = setInterval(() => {
                setTimer((prevTimer) => {
                    const [minutes, seconds] = prevTimer.split(':').map(Number);
                    if (seconds === 0) {
                        if (minutes === 0) {
                            clearInterval(interval);
                            return '0:00';
                        }
                        return `${minutes - 1}:59`;
                    }
                    return `${minutes}:${seconds - 1 < 10 ? '0' : ''}${seconds - 1}`;
                });
            }, 1000);
        }

        return () => clearInterval(interval);
    }, [emailSentConfirmation, timer]);


    return (
        <div className="wrapper">
            <div className="d-flex justify-content-center" style={{paddingTop: "40px", cursor: "pointer"}} onClick={() => navigate('/')}>
                <img src={Logo} alt="Melee Academy Logo" style={{width: "50px", marginRight: "12px"}}/>
                <h2 style={{fontWeight: 600}}>Melee Academy</h2>
            </div>
            {emailSentConfirmation && (
                <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
                    <div className='d-flex flex-column custom-container'>
                        <h2 className=' text-center' style={{fontWeight: 400}}>Email Sent</h2>
                        <p className='text-center mb-3'>We've sent a password reset link to your email. Click the link in the email to be redirected to a secure page where you can reset your password.</p>
                        <p className='text-center mb-3'>The email should arrive within a few minutes. If you don't see it, please check your <strong>spam</strong> or <strong>junk</strong> folder.</p>
                        <p className='microtext text-center mb-3'><strong>Didn't receive it?</strong> You can request a new link in {timer}</p>
                        {timer === '0:00' && (
                            <button className='rounded w-100' style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600, marginTop: "10px"}} disabled={processing} onClick={(event) => {handleForgotPassword(event);}}>Resend Email</button>
                        )}
                    </div>
                </div>
            )}
            {!emailSentConfirmation && (
                <div className='background-grid d-flex flex-column justify-content-center align-items-center landscape-spacing' style={{minHeight: "80vh"}}>
                    <div className='d-flex flex-column custom-container'>
                        <h2 className=' text-center text-md-start' style={{fontWeight: 400}}>Forgot Password</h2>
                        {validationErrors && (
                            <div className="alert bg-danger text-white" role="alert">
                                {validationErrors.map((err) => {
                                    return (
                                        <p key={err} style={{marginBottom: "0px", fontSize: "14px", color: "white"}}>
                                            {err}
                                        </p>
                                    );
                                })}
                            </div>
                        )}

                        <p className='text-center text-md-start mb-4'>Enter your email address to reset your password. If an account with the provided email exists, a password reset link has been sent.</p>

                        <input
                            className="custom-input rounded"
                            type="text"
                            placeholder="Email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            style={{ marginBottom: "20px", height: "45px", backgroundColor: "#171A29" }}
                        />

                        <button className='rounded w-100' style={{backgroundColor: '#FFCC19', height: "45px", fontWeight: 600}} disabled={processing} onClick={(event) => {handleForgotPassword(event);}}>Reset Password</button>
                    </div>
                </div>
            )}
        </div>
    )
}

export default ForgotPassword